import { Controller, useForm, useWatch } from 'react-hook-form';
import { EditSubscriptionRowProps, EditSubscriptionRowSchema } from './EditSubscriptionRow.types';
import { yupResolver } from '@hookform/resolvers/yup';
import { getEditSubscriptionSchema } from './EditSubscriptionRow.schema';
import { useEffect, useMemo, useState } from 'react';
import { confirmationBisData } from './EditSubscriptionRow.data';
import Select from '../../../../../../commons/Select/Select';
import Input from '../../../../../../commons/Input/Input';

export default ({
  NAFList,
  index,
  defaultValue,
  choosedNAFCodes,
  onChange: onChangeChooseNAFCodes,
  onAdd
}: EditSubscriptionRowProps) => {
  const formProps = useForm<EditSubscriptionRowSchema>({
    resolver: yupResolver(getEditSubscriptionSchema),
    mode: 'onChange',
    reValidateMode: 'onChange',
  });

  const {
    control,
    formState: { errors, isValid },
    setValue
  } = formProps;

  const NAFCode = useWatch({
    control,
    name: 'fieldOfActivity',
  });

  const [inputValue, setInputValue] = useState<string>()

  useEffect(() => {
    if (defaultValue) {
      setValue('fieldOfActivity', defaultValue.value, { shouldValidate: true })
    }
  }, [defaultValue])

  const updatedFormData = useMemo(
    () =>
      confirmationBisData.map((row) =>
        row.map((item) => {
          switch (item.name) {
            case 'fieldOfActivity':
              return {
                ...item,
                options: [
                  ...(NAFList
                    ?.filter((item) => item.description.toLowerCase().includes(inputValue?.toLowerCase() || 'Not in list'))
                    ?.map(({ NAF_code, description }) => ({
                    label: description,
                    value: NAF_code.toString(),
                  })) || [])
                ]
              };
            default:
              return item;
          }
        })
      ),
    [NAFList, inputValue, choosedNAFCodes, index]
  );

  return (
    <div 
      key={`row#${index}`} 
      className="form__row register__confirmation-bis-row"
      style={{
        width: 'calc(100% - var(--spacing-m))'
      }}
    >
      {updatedFormData.map((row) =>
        row.map(({ name, placeholder, label, options, onChangeValue, ...props }, inputIndex) => (
          <Controller
            key={`controlledInput#${inputIndex}`}
            name={name}
            render={({ field: { onChange } }) =>
              <div className='flex-column' style={{ flex: 1 }}>
                  <Select
                    key={`${name}#${index}`}
                    placeholder={placeholder || ''}
                    error={errors[name]?.message as string}
                    onInputChange={(value: string) => setInputValue(value)}
                    {...{ label, options }}
                    {...props}
                    defaultValue={defaultValue}
                    // @ts-ignore
                    onChange={({ value, label }: SelectOption) => {
                      onChangeChooseNAFCodes(index, { value, label });
                      onChange(value);
                      setInputValue(value);
                      if (onChangeValue) {
                        onChangeValue(value);
                      }
                    }}
                    // @ts-ignore
                    noOptionsMessage={({ inputValue }) => !inputValue ? 'Chercher un domaine' : 'Aucun résultat trouvé'}
                  />
                  {NAFCode === 'custom' &&
                    <Input
                      placeholder="Entrez un domaine d'activité"
                      onChange={(e) => {
                        const value = e.target.value
                        onChangeChooseNAFCodes(index, { value, label: value })
                      }}
                    />
                  }
                </div>
            }
            {...{ control }}
          />
        ))
      )}
      {choosedNAFCodes.length < 3 &&
        <button
          onClick={(e) => {
            e.preventDefault();
            onAdd();
          }}
          disabled={!isValid}>
          +
        </button>
      }
    </div>
  );
};
